import { ChangeDetectionStrategy, Component, inject } from '@angular/core';

import { AppLoaderComponent } from 'app/shared/components/app-loader/app-loader.component';
import { PlayerService } from '../../data-access/player.service';
import { PlayerTypes } from '../../data-access/player.config';

@Component({
  selector: 'player-loading-spinner',
  standalone: true,
  imports: [AppLoaderComponent],
  templateUrl: './player-loading-spinner.component.html',
  styleUrl: './player-loading-spinner.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PlayerLoadingSpinnerComponent {
  private playerService = inject(PlayerService);
  public showLoadingSpinner = this.playerService.getIsLoading();
}
